import { $pageId, $setSourcePath, FunnelLogType } from './share';
import { getParam } from '../utils';
import { getUserToken } from '../getUserToken';
import ajax from '../common/ajax';
import Urls, { isTest } from '../common/Urls';
var originalSourcePath = '';
/**
 * 页面打点附加信息缓存
 */
var pageViewExtraInfo;
export function getOriginalSourcePath() {
    if (originalSourcePath)
        return originalSourcePath;
    originalSourcePath = getParam('sourcePath');
    if (originalSourcePath) {
        originalSourcePath = originalSourcePath.toLowerCase();
    }
    else {
        originalSourcePath = 'other';
    }
    return originalSourcePath;
}
export function normalizeSourcePath(sourcePath) {
    if (!sourcePath)
        return '';
    return sourcePath.replace(/:/g, '_').toLowerCase();
}
/**
 * 上传漏斗打点数据
 * @param data  打点数据
 */
export function uploadFunnelLog(data) {
    getUserToken().then(function (userSign) {
        ajax({
            url: Urls.userAnalysis,
            type: 'post',
            headers: userSign,
            data: Object.assign({}, data, {
                extraInfo: data.extraInfo ? JSON.stringify(data.extraInfo) : ''
            }),
            success: function () {
                if (isTest) {
                    console.info("[log] \u6F0F\u6597\u6253\u70B9\u4E0A\u4F20\u6210\u529F\uFF1A", data);
                }
            },
            error: function (error) {
                if (isTest) {
                    console.info("[log] \u6F0F\u6597\u6253\u70B9\u4E0A\u4F20\u5931\u8D25\uFF1A", error);
                }
            }
        });
    });
}
/**
 * 漏斗打点
 * @param options
 * @returns
 */
export function funnelLog(options) {
    /**
     * 数据源路径，用:分隔
     * @type string
     */
    var originalSourcePath = getOriginalSourcePath();
    if (options.funnelLogType === FunnelLogType.Source ||
        options.funnelLogType === FunnelLogType.SourceClick
        ? !options.sourcePath
        : !originalSourcePath) {
        console.warn('[Log] 未知来源，停止漏斗打点', options);
        return;
    }
    var sourcePath = normalizeSourcePath(options.sourcePath);
    var currentSourcePath = '';
    switch (options.funnelLogType) {
        // 源入口，如蹦蹦等
        case FunnelLogType.Source:
            currentSourcePath = sourcePath || originalSourcePath || '';
            $setSourcePath(currentSourcePath);
            break;
        // 源入口中的点击事件，如点击蹦蹦中的广告按钮
        case FunnelLogType.SourceClick:
            currentSourcePath = (sourcePath || originalSourcePath) + ":sourceclick";
            break;
        // 点击事件，如点击收银台中的支付按钮
        case FunnelLogType.Click:
            currentSourcePath = originalSourcePath + ":" + normalizeSourcePath($pageId) + ":" + sourcePath;
            if (pageViewExtraInfo) {
                options.extraInfo = Object.assign({}, pageViewExtraInfo, options.extraInfo);
            }
            break;
        // 页面访问
        default:
            currentSourcePath = originalSourcePath + ":" + sourcePath;
            $setSourcePath(currentSourcePath);
            // 缓存页面打点的附加信息
            if (options.extraInfo) {
                pageViewExtraInfo = options.extraInfo;
            }
            break;
    }
    uploadFunnelLog({
        sourcePath: currentSourcePath,
        extraInfo: options.extraInfo || ''
    });
}
//# sourceMappingURL=funnelLog.js.map